import { useEffect, useState } from "react";
import api from "@/lib/api";

const FALLBACKS = [
  "https://customer-assets-lqy194kg.emergentagent.net/job_ai-photo-prompts-6/artifacts/qtz8sfj2_IMG_8407.jpeg",
  "",
];

function resolveUrl(u) {
  if (!u) return "";
  if (u.startsWith("http")) return u;
  const base = process.env.REACT_APP_BACKEND_URL || "";
  return `${base}${u}`;
}

/**
 * Two independent partner banner slots stacked, both identical fixed size,
 * placed above the footer on public pages. Clearly labelled "Our tech partner"
 * so it cannot be confused with a Google AdSense unit.
 */
export default function PartnerBanner() {
  const [banners, setBanners] = useState([]);

  useEffect(() => {
    let cancelled = false;
    api
      .get("/banners")
      .then(({ data }) => {
        if (!cancelled) setBanners(data.banners || []);
      })
      .catch(() => {
        if (!cancelled)
          setBanners([
            { slot: 0, image_url: FALLBACKS[0], link_url: "" },
            { slot: 1, image_url: FALLBACKS[1], link_url: "" },
          ]);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const slots = [0, 1].map((i) => {
    const b = banners.find((x) => x.slot === i);
    return {
      slot: i,
      url: resolveUrl(b?.image_url || FALLBACKS[i]),
      link: b?.link_url || "mailto:saivigneshseva@gmail.com?subject=Enquiry%20via%20giprompthub.com",
    };
  });

  return (
    <section
      data-testid="partner-banner"
      className="border-t border-white/10 bg-[#050505]"
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-10 space-y-4 md:space-y-5">
        <div className="flex items-center justify-between">
          <span className="font-mono-label text-white/45">Our tech partner</span>
          <span className="font-mono-label text-white/25 hidden sm:inline">editorial</span>
        </div>

        {slots.map(({ slot, url, link }) => (
          <a
            key={slot}
            href={link}
            data-testid={`partner-banner-slot-${slot}`}
            aria-label={`Partner banner slot ${slot + 1}`}
            className="block rounded-2xl overflow-hidden border border-white/10 hover:border-[#00E5FF]/40 transition-colors bg-[#0E0E12]"
          >
            <div className="w-full aspect-[1391/365] bg-[#0E0E12] relative">
              {url ? (
                <img
                  src={url}
                  alt={`Partner banner ${slot + 1}`}
                  loading="lazy"
                  decoding="async"
                  className="absolute inset-0 w-full h-full object-cover"
                />
              ) : (
                <div className="absolute inset-0 flex items-center justify-center text-white/30 font-mono-label">
                  Banner slot {slot + 1} — upload from admin
                </div>
              )}
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}
